import React from "react";
import { motion } from "framer-motion";
import { Users, IndianRupee, Sparkles, Zap } from "lucide-react";

const STATS = [
  { value: "5", label: "MEMBERS / GROUP", icon: Users },
  { value: "₹", label: "INR FIRST. UPI READY", icon: IndianRupee },
  { value: "0", label: "AWKWARD MATHS", icon: Sparkles },
  { value: "1", label: "TAP TO SETTLE", icon: Zap },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-36 bg-[#EDE9FE]/60 backdrop-blur-sm border-y border-[#0F2C5A]/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.7 }}
            className="md:col-span-5"
          >
            <p
              data-testid="about-eyebrow"
              className="text-[#3056F5] font-bold tracking-[0.35em] text-xs mb-5"
            >
              ABOUT THE APP
            </p>
            <h2
              data-testid="about-heading"
              className="font-display uppercase text-[#0F2C5A] leading-[0.95] text-[clamp(2.2rem,5.5vw,4.5rem)]"
            >
              Trips end.
              <br />
              <span className="text-[#3056F5]">Bills don't.</span>
              <br />
              We fix that.
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="md:col-span-7 md:pt-6"
          >
            <p className="text-lg md:text-xl text-[#14254B] leading-relaxed">
              <span className="font-display text-[#0F2C5A]">Qontri</span> is the
              expense companion built for Indian travel crews. Add an expense
              in seconds, let the app handle the splits, and settle up with a
              branded UPI QR — no spreadsheets, no group-chat passive
              aggression.
            </p>
            <p className="mt-6 text-base md:text-lg text-[#14254B]/80 leading-relaxed">
              Smart contributions earn members fun group roles —{" "}
              <span className="font-semibold text-[#0F2C5A]">The ATM</span>,{" "}
              <span className="font-semibold text-[#0F2C5A]">The Borrower</span>
              , <span className="font-semibold text-[#0F2C5A]">The Equalizer</span>
              {" "}— turning settlement into a story your group will actually
              talk about.
            </p>
          </motion.div>
        </div>

        {/* Stat strip */}
        <div
          data-testid="about-stats"
          className="mt-20 md:mt-28 grid grid-cols-2 md:grid-cols-4 gap-px bg-[#0F2C5A]/10 rounded-3xl overflow-hidden border border-[#0F2C5A]/10"
        >
          {STATS.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="bg-[#F0EAFD] p-8 md:p-10 group hover:bg-[#0F2C5A] hover:text-[#F0EAFD] transition-colors duration-500"
              >
                <Icon className="w-6 h-6 text-[#3056F5] group-hover:text-[#F0EAFD] transition-colors" />
                <div className="mt-6 font-display text-5xl md:text-6xl leading-none">
                  {s.value}
                </div>
                <div className="mt-3 text-[11px] tracking-[0.2em] font-bold opacity-70">
                  {s.label}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
